import { useMutation } from "@tanstack/react-query";
import type { ColumnFiltersState } from "@tanstack/react-table";
import { clientToServerFiltering } from "../../../components/table/utils";
import { useDates } from "../../../dates/DatesContext";
import { useAppSelector } from "../../../redux/hooks";
import { apiClient } from "../../../zodios/client";

export const useV4SearchQueryPerformanceReportExport = (filters: ColumnFiltersState, search?: string) => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const { start, end, preStart, preEnd } = useDates();

  return useMutation({
    mutationFn: async () =>
      await apiClient.getV4SearchQueryPerformanceExport({
        queries: {
          marketplace: marketPlace,
          start_date: start.format("YYYY-MM-DD"),
          end_date: end.format("YYYY-MM-DD"),
          start_date_previous: preStart.format("YYYY-MM-DD"),
          end_date_previous: preEnd.format("YYYY-MM-DD"),
          filters: clientToServerFiltering(filters),
          search: search ? search.split(",") : undefined,
        },
        responseType: "blob",
      }),
  });
};
